// import { useRootElement } from "@/providers/RootElement/hooks";
import { useOutsideClick } from "@/providers/RootElement/hooks/events";
import { ArrowUp } from "@/svg";
import {
	Select,
	SelectArrow,
	SelectItem,
	SelectLabel,
	SelectPopover,
	SelectProvider,
} from "@ariakit/react";
import { SVGIcon } from "hsl-core/Components";
import {
	type PropsWithChildren,
	type RefObject,
	useRef,
	useState,
} from "react";
import { arrow, item, popover, select } from "./DropdownSelect.css";

export default function DropdownSelect<O extends { value: string }>({
	value,
	options,
	renderValue = (v) => v,
	renderItem = (i) => i,
	children,
	onChange,
	className,
	onOpen,
	sameWidth = true,
}: PropsWithChildren<{
	value: string;
	options: O[];
	renderValue?: (value: string) => React.ReactNode;
	renderItem?: (value: string, index: number) => React.ReactNode;
	onChange?: (value: string) => void;
	onOpen?: (open: boolean) => void;
	className?: string;
	sameWidth?: boolean;
}>) {
	// const root = useRootElement();
	const [open, setOpen] = useState(false);
	const buttonRef = useRef<HTMLButtonElement>(null);
	const popoverRef = useRef<HTMLDivElement>(null);
	useOutsideClick(
		[
			buttonRef as RefObject<HTMLElement>,
			popoverRef as RefObject<HTMLDivElement>,
		],
		() => setOpen(false),
	);

	// const portalElement = document.createElement("div", {});
	// portalElement.style.position = "relative";
	// portalElement.style.zIndex = "99999";
	// root.appendChild(portalElement);

	return (
		<SelectProvider
			setValueOnMove
			open={open}
			setOpen={(_open) => {
				setOpen(_open);
				onOpen?.(_open);
			}}
			value={value}
			setValue={onChange}
		>
			{children && <SelectLabel className="label">{children}</SelectLabel>}
			<Select
				className={`${select({ type: "regular" })} ${className}`}
				ref={buttonRef}
			>
				{renderValue(value)}{" "}
				<SelectArrow
					render={() => (
						<SVGIcon
							icon={ArrowUp}
							className={arrow({ open })}
							params={{ fill: "#fff" }}
						/>
					)}
				/>
			</Select>
			<SelectPopover
				className={popover({ sameWidth })}
				ref={popoverRef}
				sameWidth={sameWidth}
				flip={false}
			>
				{options.map((option, i) => (
					<SelectItem key={option.value} value={option.value} className={item}>
						{renderItem(option.value, i)}
					</SelectItem>
				))}
			</SelectPopover>
		</SelectProvider>
	);
}
